const scheduledServicesStore = {
  scheduledServiceCreated: 'Servicio programado creado exitosamente',
  scheduledServicesCreated: 'Servicios programados creados exitosamente',
  scheduledServiceDeleted: 'Servicio programado eliminado exitosamente',
  scheduledServiceUpdated: 'Servicio agendado actualizado con éxito',
};

export default scheduledServicesStore;
